import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../content/site'
import type { HomeCopy } from '../content/home'
import styles from './StoreBadges.module.css'

/**
 * The two store buttons, or the truth instead.
 *
 * Ronin is in both stores. If either URL in content/site.ts is ever emptied, this renders
 * one sentence rather than two buttons that go nowhere: a dead button reads as a broken
 * site, and a link to "#" is the same promise the site is not allowed to make.
 */
export default function StoreBadges({ copy }: { copy: HomeCopy }) {
  const live = Boolean(APP_STORE_URL && GOOGLE_PLAY_URL)

  return (
    <div className={styles.wrap}>
      {live ? (
        <div className={styles.badges}>
          <a className={`${styles.badge} ${styles.primary}`} href={APP_STORE_URL}>
            <span className={styles.small}>{copy.storeSmallApple}</span>
            <span className={styles.store}>App Store</span>
          </a>
          <a className={`${styles.badge} ${styles.secondary}`} href={GOOGLE_PLAY_URL}>
            <span className={styles.small}>{copy.storeSmallGoogle}</span>
            <span className={styles.store}>Google Play</span>
          </a>
        </div>
      ) : (
        <p className={styles.coming}>{copy.storeComing}</p>
      )}
      <p className={styles.note}>{copy.storeNote}</p>
    </div>
  )
}
